import type {TrustAccountGuestDTO} from '@sollapay/types';

/** A guest is shown by the name they saved, else the email they were invited by. */
export function getGuestDisplayName(guest: Pick<TrustAccountGuestDTO, 'name' | 'email'>): string {
  return guest.name ?? guest.email;
}
